import { getState } from '~shared/utils/state';

/**
 * Returns the jitter value (seconds) for Racing Widgets
 *
 * @returns {Integer} Jitter value (defaults to 0 if the key is missing)
 */
export function getRacingWidgetJitter() {
    return getState('racingwidget:jitter') || 0;
}

/**
 * Returns competition only sport slugs
 *
 * @returns {Array} A list of competition only sport slugs
 */
export const getCompetitionOnlySlugs = () => getState('competitions_only_sport_slugs') || [];

/**
 * Returns grouping only sport slugs
 *
 * @returns {Array} A list of grouping only sport slugs
 */
    export const getMultiGroupedOnlySlugs = () => getState('grouping_only_sport_slugs') || [];

/**
 * Returns Branded Translations
 *
 * @returns {Array} A list of grouping only sport slugs
 */
export const getBrandedTranslations = () => getState('brand_translations') || [];

/**
* Returns slugs of sports that don't display selections on inplay homepage
* This can be used with to unusual layouts that are not developed yet but still have an inplay event page
* @returns {Array} A list of grouping only sport slugs
*/
export const getHideInplaySelections = () => getState('hide_inplay_selections') || [];

/**
 * Returns the world_cup_hub config key to enable/disable
 * displaying the WC Hub widget.
 *
 * @returns {Boolean} The flag (defaults to false if site_config key is missing)
 */
export const getWorldCupHubEnabled = () => getState('worldcuphub:enabled');

/**
 * Returns World Cup Hub URL
 *
 * @returns {String} World Cup Hub Url
 */
 export const getWorldCupHubUrl = () => getState('worldcuphub:iframe');

 /**
 * Returns World Cup Hub blocked countries
 *
 * @returns {Array} List of countries blocked by WC Hub
 */
  export const getWorldCupHubExcludedCountries = () => getState('worldcuphub:excluded_countries') || [];
